import { isObject } from './isObject';
export var deepRename = function deepRename(obj, getNewKey) {
  var out;
  if (Array.isArray(obj)) {
    out = [];
    for (var i = 0; i < obj.length; i += 1) {
      out.push(deepRename(obj[i], getNewKey));
    }
  } else if (isObject(obj)) {
    out = {};
    Object.keys(obj).forEach(function (key) {
      var newKey = getNewKey(key);
      out[newKey] = obj[key];
      if (isObject(out[newKey])) {
        out[newKey] = deepRename(out[newKey], getNewKey);
      }
    });
  }
  return out || obj;
};